import React from 'react';
import { Col, Row } from 'antd';
import { MenuItem } from '~/types/Menu';
import ItemCard from './components/ItemCard';
import { useMenuAvailabilityMap } from '~/App/hooks/useMenuAvailability';

const MenuList = ({ items }: { items: MenuItem[] }) => {
  const map = useMenuAvailabilityMap();

  return (
    <div style={{ marginLeft: 8, marginRight: 8 }}>
      <Row gutter={[8, 8]}>
        {items.map((item) => (
          <Col span={8} key={item.id}>
            <ItemCard item={item} availability={map[item.id]} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default MenuList;
